import React from 'react';

import { Hidden, useMediaQuery, useTheme } from '@material-ui/core';
import classNames from 'classnames';

import { makeBtStyles } from '../../Theme';
import { ReactComponent as CheckedIcon } from './stepperSvg/stepperCheckmark.svg'
import { ReactComponent as MissedIcon } from './stepperSvg/stepperX.svg'


const useStepperStyles = makeBtStyles( theme => ({
  activeCheck: {
    '& path': {
      fill: 'white',
    }
  },
  inactiveCheck: {
    '& path': {
      fill: '#DEDEDE',
    }
  },
  circle: {
    zIndex: '1',
    lineHeight: '1em',
    borderRadius: '50%',
    border: '2px solid transparent' 
  },
  activeCircle: {
    backgroundColor: theme.colors.main,
  },
  inactiveCircle: {
    backgroundColor: '#DEDEDE',
  },
  text:{
    textAlign: 'center',
  },
  activeText: {

  },
  inactiveText: {
    opacity: '40%',
  },
  stepBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  },
  dividerLine: {
    zIndex: '0',
    position: 'absolute',
    width: '100%',
  },
  activeDivider: {
    backgroundColor: theme.colors.main,
  },
  inactiveDivider: {
    backgroundColor: '#DEDEDE',
  },
  activeIcon: {
    '& path': {
      fill: theme.colors.main,
    }
  },
  inactiveIcon: {
    '& path': {
      opacity: '40%',
    }
  }
}))

export default function Step({ classes={}, label, Icon, active, index, current, showMiss }:{
  classes?: {
    circle?: string,
    check?: string,
    missed?: string,
    dividerLine?: string,
    stepBlock?: string,
    text?: string,
    icon?: string,
  },
  label: string,
  Icon: any,
  active: boolean,
  index: number,
  current: boolean,
  showMiss?: boolean
}){
  const defaultClasses = useStepperStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const icon = <Icon className={classNames(classes.icon, { [defaultClasses.activeIcon]: active, [defaultClasses.inactiveIcon]: !active })} />;

  return (
    <div className={`${defaultClasses.stepBlock} ${classes?.stepBlock}`}>
      <div className={`${defaultClasses.circle} ${classes?.circle} ${active ? defaultClasses.activeCircle : defaultClasses.inactiveCircle}`} >
        { !!showMiss ?
          <MissedIcon className={`${defaultClasses.check} ${classes?.missed} ${active ? defaultClasses.activeCheck : defaultClasses.inactiveCheck}`}/>
          :
          <CheckedIcon className={`${defaultClasses.check} ${classes?.check} ${active ? defaultClasses.activeCheck : defaultClasses.inactiveCheck}`}/>
        }
      </div>
      <div className={ (index !== 0 ) ? `${defaultClasses.dividerLine} ${classes?.dividerLine} ${active ? defaultClasses.activeDivider : defaultClasses.inactiveDivider}` : ''}></div>

    <Hidden smDown>
      {icon}
    </Hidden>

      { (current && isMobile)  && <> 
        { icon }
      </>}

      <Hidden mdDown>
        <div className={`${defaultClasses.text} ${classes?.text} ${active ? '' : defaultClasses.inactiveText}`}> { label } </div>
      </Hidden>

      { (current && !isDesktop)  && <>
        <Hidden smDown>
          <div className={`${defaultClasses.text} ${classes?.text} ${active ? '' : defaultClasses.inactiveText}`}> { label } </div>
        </Hidden>
      </>}

    </div>
  )
}